import React, { Component } from "react";
import { Link } from "react-router-dom";
// import axios from 'axios';
import { constantApp } from "../../../../config/constant";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getPeople } from "../../../../action";

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idProduce: this.props.idProduce,
      data: [
        { idProduce: "1", ProduceName: "دستگاه شل پیچ" },
        { idProduce: "2", ProduceName: "دستگاه فاق ماشین" },
        { idProduce: "3", ProduceName: "دستگاه چند لاکنی" },
        { idProduce: "4", ProduceName: "دستگاه اپتیک" },
        { idProduce: "5", ProduceName: "دستگاه مستر" },
        { idProduce: "6", ProduceName: "دستگاه هاب" },
      ],
    };
  }

  componentDidMount() {
    //this.props.getPeople()
    // console.log('///////////////')
    // console.log('#########', this.props.getPeople())
    // let url = `${constantApp.SERVERIP}/PHP/Produce/Select_Produce.php`;
    // let param = {
    //     idProduce: this.state.idProduce,
    // }
    // let data = await axios.post(url, param)
    //     .then(function (response) {
    //         return response.data;
    //     })
    //     .catch(function (error) {
    //         // this.setState({ isNetworkError: true })
    //     });
    // if (data !== undefined && data.length > 0) {
    //     this.setState({
    //         data,
    //         isLoading: false
    //     })
    // }
  }

  render() {
    return (
      <div className="col col-md-4 col-md-pull-8">
        <div className="service-single-sidebar">
          <div className="services-link-widget widget">
            <ul>
              {this.state.data.map((item) => {
                return (
                  <li
                    className={
                      item.idProduce === this.state.idProduce ? "current" : null
                    }
                    key={item.idProduce}
                  >
                    <Link
                      // onClick={ forceUpdate()}
                      to={{
                        pathname: `/produce/${item.idProduce}`,
                        state: { from: "root" },
                      }}
                    >
                      {" "}
                      {item.ProduceName}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="download-brocher-widget widget">
            <a
              href={`${constantApp.SERVERIP}/APAFAN/Documents/${this.state.idProduce}.pdf`}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-file-pdf-o"></i> دانلود بروشور
            </a>
          </div>
          <div className="widget contact-widget">
            <h3>تماس برای مشاوره؟</h3>
            <p>جهت تعیین وقت مشاوره حضوری لطفا فرم مشاوره را تکمیل نمایید.</p>

            <br />
            <Link
              to={{ pathname: "/consult", state: { from: "root" } }}
              className="theme-btn"
            >
              مشاوره
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  idProduce: PropTypes.string,
};

function mapStateToProps(state) {
  // console.log('++++++++++', state)

  return {
    allPeople: state.getPeople,
  };
}

export default connect(mapStateToProps, { getPeople })(Sidebar);
